import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useData } from '@hooks/useData';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IContaLinha } from '@model/ContaLinha';
import { IContaLinhaFilter, useContaService } from '@services/ContaService';
import React from 'react';
import { ContaDetalheTable } from './ContaDetalheTable';

export type ContaDetalheModalProps = {
    contaId: number
    modal: IModalWindow
}

export function ContaDetalheModal ({ contaId, modal }: ContaDetalheModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const contaService = useContaService();

    const data = useData<IContaLinha, IContaLinhaFilter>({
        filter: {
            linhaOrfa: useField("0")
        }
    });

    const handleEnter = React.useCallback(() => {
        data.filter.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (!loading.isLoading) {
            loading.start();
            contaService.listarItens(contaId, data.requestedData)
                .then(data.handleResultResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData, contaId])

    return (
        <ModalWindow
            modal={modal}
            disabled={loading.isLoading}
            size="md"
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle
                title={`Linhas da Conta ${contaId}`}
            />

            <ModalWindowContent>
                <TableWrapper>
                    <ContaDetalheTable 
                        data={data}
                    />
                </TableWrapper>
            </ModalWindowContent>
        </ModalWindow>
    )
}